import { rxTaskFactory } from 'src/js/helper/mobx-tasks';
import { DeleteFirmwareResponse } from 'src/js/model/api/response/delete-firmware-response';
import { MonitorFirmwareUploadResponse } from 'src/js/model/api/response/monitor-firmware-upload-response';
import { apiClient } from 'src/js/api';
import { SameTypeNetworkTaskGenerator } from 'src/js/util/global-type';

export const createDeleteFirmwareTask: SameTypeNetworkTaskGenerator<DeleteFirmwareResponse> = () =>
  rxTaskFactory((filename: string) => apiClient.settingsUpgradeController.deleteFirmware(filename));

export const createMonitorFirmwareUploadTask: SameTypeNetworkTaskGenerator<MonitorFirmwareUploadResponse> = (
  _responseHandler,
  errorHandler,
) =>
  rxTaskFactory((filename: string) =>
    apiClient.settingsUpgradeController.monitorFirmwareUpload(filename, errorHandler),
  );
